import React, { useEffect, useRef, useState } from "react";
import { Table } from "antd";

import Preloader from "~/components/Preloader";
import StaffFilter from "~/pages/Staff/ui/StaffFilter/StaffFilter";
import DynamicTable from "~/pages/StaffBonus/DynamicTable";
import Wrapper from "~/shared/ui/Wrapper";
import { IDynamicTable } from "~/app/type/common";
import { useCourses } from "~/entity/Courses";
import { useEmployee } from "~/entity/Employee";
import {
  EmployeeEducationStatisticsCourseDetailsReportGetterParams,
  EmployeeEducationStatisticsCoursesDetailsReportGetterParams,
} from "~/entity/Employee/model/schema";
import {
  useURLParamsGetter,
  useURLParamsSetter,
} from "~/hooks/useURLParamsSetter";
import { TTrainingFilter } from "~/pages/StaffTraining/ui/StaffTrainingFilter/model/config";
import {
  isCourseParams,
  toServerForCourse,
  toServerForCourses,
} from "~/pages/StaffTrainingDetails/model/adapter";
import {
  TTrainingCourseDetailsFilter,
  TTrainingCoursesDetailsFilter,
} from "~/pages/StaffTrainingDetails/model/config";
import { StaffTrainingFactControl } from "~/pages/StaffTrainingDetails/ui/StaffTrainingFactControl/StaffTrainingFactControl";
import { useNotify } from "~/shared/hooks/useNotify";

const staffDetailPages = {
  "/staff/training/fact": "fact",
  "/staff/training/completed": "completed",
  "/staff/training/required": "required",
};

export const StaffTrainingDetails = () => {
  const setQuerySearch = useURLParamsSetter();
  const settedFilter = useURLParamsGetter<
    TTrainingCoursesDetailsFilter & TTrainingCourseDetailsFilter
  >();
  const currentDetailKey = staffDetailPages[location.pathname];
  const isFact = currentDetailKey === "fact";
  const isRequired = currentDetailKey === "required";
  console.log(isRequired, "isRequired");

  const { notifyReport } = useNotify();
  const { coursesGetSingle, getExpectationsSingle } = useCourses();
  const {
    getEmployeeCoursesRequired,
    getEmployeeCoursesRequiredFileHash,
    getCourseByExpectation,
    getCourseByExpectationFileHash,
    getCoursesByExpectation,
    getCoursesByExpectationFileHash,
  } = useEmployee();

  const resolveRequest = (currentDetailKey: string, mode: "table" | "file") => {
    switch (currentDetailKey) {
      case "fact":
        return mode === "table"
          ? getCoursesByExpectation
          : getCoursesByExpectationFileHash;
      case "required":
        return mode === "table"
          ? getEmployeeCoursesRequired
          : getEmployeeCoursesRequiredFileHash;
      default:
        return mode === "table"
          ? getCourseByExpectation
          : getCourseByExpectationFileHash;
    }
  };

  const reportGetter = {
    table: resolveRequest(staffDetailPages[location.pathname], "table"),
    fileHash: resolveRequest(staffDetailPages[location.pathname], "file"),
  };

  const [loadingReport, setLoadingReport] = useState(false);
  const [loadingReportDownload, setLoadingReportDownload] = useState(false);

  const [factTable, setFactTable] = useState<{ table: IDynamicTable }>(null);
  const debouncedRef = useRef(null);

  const onFilterSubmit = (value: TTrainingFilter) => {
    setQuerySearch(value);
  };

  const params = isFact
    ? toServerForCourses(settedFilter)
    : toServerForCourse(settedFilter);

  const [currentTitle, setCurrentTitle] = useState<string>("Загрузка...");
  useEffect(() => {
    if (isCourseParams(params)) {
      coursesGetSingle(params.courseId)
        .then((el) => {
          setCurrentTitle(el.data.course.name);
        })
        .catch(() => setCurrentTitle("Не определен"));
    } else {
      getExpectationsSingle(params.expectationId)
        .then((el) => {
          setCurrentTitle(
            el.data.expectation.positions
              .map((position) => `${position.code} ${position.name}`)
              .join(", ")
          );
        })
        .catch(() => setCurrentTitle("Не определен"));
    }
  }, []);

  const onDownload = () => {
    setLoadingReportDownload(true);
    reportGetter
      .fileHash(params)
      .then((res) => {
        if (res.data.fileHash) {
          notifyReport(res.data.fileHash);
        }
      })
      .finally(() => setLoadingReportDownload(false));
  };

  const getReportByFilter = (
    filter:
      | EmployeeEducationStatisticsCourseDetailsReportGetterParams
      | EmployeeEducationStatisticsCoursesDetailsReportGetterParams
  ) => {
    setLoadingReport(true);
    reportGetter
      .table(filter)
      .then((res) => {
        setFactTable(res.data);
      })
      .finally(() => setLoadingReport(false));
  };

  useEffect(() => {
    clearTimeout(debouncedRef.current);
    if (!!Object.keys(settedFilter).length) {
      debouncedRef.current = setTimeout(() => {
        getReportByFilter(params);
      }, 0);
    }
  }, [settedFilter]);

  const isLoading = loadingReport;

  const goBack = () => window.close();

  return (
    <Wrapper.Content
      goBackHandler={goBack}
      txtBtn={'Назад'}
      title={
        isCourseParams(params)
          ? `Курс: ${currentTitle}`
          : `Должность: ${currentTitle}`
      }
      controlComponent={
        <StaffTrainingFactControl
          onDownload={onDownload}
          disabledControl={loadingReportDownload}
        />
      }
      filterComponent={<StaffFilter onSubmit={onFilterSubmit} />}
    >
      {!isLoading ? (
        !!factTable?.table ? (
          <DynamicTable table={factTable.table} />
        ) : (
          <></>
        )
      ) : (
        <Preloader />
      )}
    </Wrapper.Content>
  );
};
